import type { AppRouteObject } from "../routes";
import { LicenseModule } from "./routes/LicenseModule";

const routes: AppRouteObject[] = [LicenseModule];

export default routes;
